/** @format */

import process from "process";
import { apiRequest } from "../Component/Utils/ApiHundler";

const API_BASE_URL = process.env.REACT_APP_API_URL;
let docViewWindow = null;

export async function docViewADM(token, docId, modelId, instanceId, clientId) {
  // Validation des paramètres pour s'assurer qu'ils ne sont pas undefined
  if (!token || !docId || !modelId || !instanceId) {
    console.error("Un ou plusieurs paramètres requis sont undefined", {
      token,
      docId,
      modelId,
      instanceId,
    });
    throw new Error("Un ou plusieurs paramètres requis sont undefined");
  }

  const apiUrl = `${API_BASE_URL}/admin/document/view`;

  const data = await apiRequest(apiUrl, {
    method: "POST",
    headers: {
      Authorization: token,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      InstanceId: instanceId,
      ModelId: modelId,
      Duration: 600,
      DocumentId: docId,
      ClientId: clientId
    }),
  });

  const presignedUrl = data.message.PresignedURL;
  if (presignedUrl) {
    const windowFeatures =
      "width=600,height=400,resizable=yes,scrollbars=yes,status=yes";
    if (docViewWindow && !docViewWindow.closed) {
      docViewWindow.location.href = presignedUrl;
    } else {
      docViewWindow = window.open(presignedUrl, "_blank", windowFeatures);
    }
    docViewWindow.focus();
  }
  return presignedUrl;
}